import { useMutation } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";

import type { ApiDocumentResponse } from "../types";

export function useDownloadCompanyDocument() {
  return useMutation({
    mutationFn: async (documentId: string) => {
      const { data } = await bffAxios.get<ApiDocumentResponse<{ presignedUrl: string }>>(
        `/company-documents/${documentId}`
      );

      window.open(data.data.presignedUrl, "_blank", "noopener,noreferrer");
    },
  });
}
